export interface AzCategory {
  name: string;
  count: number;
}

export interface PopularAzCategory {
  name: string;
  count: number;
  icon: string;
  description: string;
  image: string;
}

export const popularAzCategories: PopularAzCategory[] = [
  { name: "Restaurants", count: 214, icon: "ri-restaurant-2-line", description: "Dine-in, takeaway, cafes and sweet stalls", image: "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20cozy%20South%20Indian%20restaurant%20table%20set%20with%20fresh%20local%20dishes%2C%20brass%20utensils%20and%20banana%20leaf%20thali%2C%20soft%20natural%20window%20light%2C%20simple%20cream%20and%20terracotta%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-restaurants-001&orientation=landscape" },
  { name: "Automobile Repair & Service Centres", count: 314, icon: "ri-tools-line", description: "Car & bike servicing, repairs and spares", image: "https://readdy.ai/api/search-image?query=Clean%20editorial%20photograph%20of%20a%20bright%20car%20service%20garage%20with%20wrenches%2C%20tools%20and%20a%20lifted%20car%2C%20soft%20overhead%20light%2C%20simple%20cream%20and%20grey%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-auto-002&orientation=landscape" },
  { name: "Beauty Salons & Parlours", count: 179, icon: "ri-scissors-2-line", description: "Hair, skin, bridal and grooming services", image: "https://readdy.ai/api/search-image?query=Calm%20editorial%20photograph%20of%20a%20modern%20beauty%20salon%20interior%20with%20a%20styling%20chair%2C%20mirror%20and%20skincare%20bottles%2C%20soft%20warm%20light%2C%20simple%20cream%20and%20blush%20pink%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-salon-003&orientation=landscape" },
  { name: "Medical Stores", count: 118, icon: "ri-medicine-bottle-line", description: "Pharmacies, chemists and daily medicines", image: "https://readdy.ai/api/search-image?query=Neat%20editorial%20photograph%20of%20a%20pharmacy%20counter%20with%20medicine%20boxes%2C%20bottles%20and%20a%20green%20cross%20sign%2C%20bright%20soft%20light%2C%20simple%20cream%20and%20pale%20green%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-pharmacy-004&orientation=landscape" },
  { name: "Mobile Phone Dealers", count: 97, icon: "ri-smartphone-line", description: "Smartphones, accessories and service centres", image: "https://readdy.ai/api/search-image?query=Sleek%20editorial%20photograph%20of%20smartphones%20lined%20up%20on%20a%20display%20shelf%20with%20accessories%20and%20earbuds%2C%20soft%20studio%20lighting%2C%20simple%20cream%20and%20pale%20grey%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-mobile-005&orientation=landscape" },
  { name: "Hotels", count: 96, icon: "ri-hotel-line", description: "Hotels, resorts, homestays and lodges", image: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20photograph%20of%20a%20boutique%20hotel%20lobby%20with%20rattan%20furniture%2C%20potted%20palms%20and%20warm%20ambient%20lamps%2C%20soft%20daylight%2C%20simple%20cream%20and%20sand%20colored%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-hotel-006&orientation=landscape" },
  { name: "Tailors & Ladies Tailors", count: 88, icon: "ri-shirt-line", description: "Custom stitching, alterations and boutiques", image: "https://readdy.ai/api/search-image?query=Charming%20editorial%20photograph%20of%20a%20tailoring%20workspace%20with%20folded%20fabric%2C%20measuring%20tape%2C%20scissors%20and%20a%20sewing%20machine%2C%20soft%20warm%20light%2C%20simple%20cream%20and%20beige%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-tailor-007&orientation=landscape" },
  { name: "Grocery Stores", count: 88, icon: "ri-store-2-line", description: "Daily-needs shops, provisions and supermarkets", image: "https://readdy.ai/api/search-image?query=Fresh%20editorial%20photograph%20of%20grocery%20store%20shelves%20with%20rice%20bags%2C%20pulses%2C%20spices%20and%20baskets%2C%20bright%20soft%20light%2C%20simple%20cream%20and%20green%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-grocery-008&orientation=landscape" },
  { name: "Real Estate Agents", count: 87, icon: "ri-home-4-line", description: "Property sales, rentals and land dealings", image: "https://readdy.ai/api/search-image?query=Bright%20editorial%20photograph%20of%20a%20modern%20house%20model%20on%20a%20table%20with%20keys%20and%20a%20property%20blueprint%2C%20soft%20daylight%2C%20simple%20cream%20and%20warm%20beige%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-realestate-009&orientation=landscape" },
  { name: "Hospitals", count: 58, icon: "ri-hospital-line", description: "Multispeciality hospitals and emergency care", image: "https://readdy.ai/api/search-image?query=Clean%20editorial%20photograph%20of%20a%20modern%20hospital%20reception%20corridor%20with%20a%20counter%2C%20plant%20and%20soft%20lighting%2C%20simple%20cream%20and%20pale%20blue-green%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-hospital-010&orientation=landscape" },
  { name: "Wedding Photographers", count: 51, icon: "ri-camera-lens-line", description: "Weddings, events and pre-wedding shoots", image: "https://readdy.ai/api/search-image?query=Romantic%20editorial%20photograph%20of%20a%20wedding%20camera%20resting%20on%20draped%20fabric%20with%20marigold%20flowers%20and%20brass%20lamps%2C%20soft%20warm%20light%2C%20simple%20cream%20and%20gold%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-wedding-011&orientation=landscape" },
  { name: "Plumbers", count: 46, icon: "ri-drop-line", description: "Pipe fitting, leakage and bathroom repairs", image: "https://readdy.ai/api/search-image?query=Practical%20editorial%20photograph%20of%20plumbing%20tools%20with%20pipes%2C%20a%20wrench%20and%20fittings%20on%20a%20light%20surface%2C%20soft%20light%2C%20simple%20cream%20and%20warm%20grey%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=280&seq=popcat-plumber-012&orientation=landscape" },
];

export const azCategories: AzCategory[] = [
  // A
  { name: "Aadhaar & PAN Card Centres", count: 30 },
  { name: "Aadhaar and PAN Card Centres", count: 30 },
  { name: "Abacus Classes", count: 6 },
  { name: "AC Sales & Service", count: 80 },
  { name: "Accounting & Book Keeping", count: 19 },
  { name: "Acupressure Clinics", count: 7 },
  { name: "Acupuncture Clinics", count: 6 },
  { name: "Adhesive Dealers", count: 9 },
  { name: "Advertising & Marketing Agencies", count: 68 },
  { name: "Advocates & Lawyers", count: 120 },
  { name: "Aerobic Classes", count: 8 },
  { name: "Agarbatti Manufacturers", count: 5 },
  { name: "Agricultural & Farm Equipment Dealers", count: 35 },
  { name: "Agro Products", count: 18 },
  { name: "Air Ambulance Services", count: 3 },
  { name: "Air Cargo Services", count: 6 },
  { name: "Air Ticket Booking", count: 12 },
  { name: "Alarm System Dealers", count: 10 },
  { name: "Allergy Doctors", count: 5 },
  { name: "Alternative Medicine", count: 9 },
  { name: "Aluminium Works", count: 16 },
  { name: "Ambulance Services", count: 14 },
  { name: "Amusement Parks", count: 7 },
  { name: "Animation Studios", count: 4 },
  { name: "Aquarium Shops", count: 5 },
  { name: "Architectural Consultants", count: 23 },
  { name: "Art Galleries", count: 8 },
  { name: "Artificial Jewellery", count: 14 },
  { name: "Astrology Consultants", count: 16 },
  { name: "Audiologists", count: 9 },
  { name: "Auditoriums", count: 13 },
  { name: "Auditors & Cost Accountants", count: 25 },
  { name: "Auto Parts & Accessories Dealers", count: 67 },
  { name: "Automobile Dealers", count: 73 },
  { name: "Automobile Finance", count: 12 },
  { name: "Automobile Repair & Service Centres", count: 314 },
  { name: "Ayurvedic Clinics", count: 21 },
  { name: "Ayurvedic Doctors", count: 27 },

  // B
  { name: "Baby Shops", count: 18 },
  { name: "Bag Dealers", count: 13 },
  { name: "Bail Bonds", count: 4 },
  { name: "Bakery & Confectionery", count: 94 },
  { name: "Bakery Equipment", count: 8 },
  { name: "Bands & Orchestras", count: 6 },
  { name: "Banquet Halls & Wedding Venues", count: 65 },
  { name: "Bar Code Dealers", count: 5 },
  { name: "Barbeque Restaurants", count: 11 },
  { name: "Bars & Pubs", count: 19 },
  { name: "Bathroom Fittings & Sanitary Ware", count: 43 },
  { name: "Battery Dealers", count: 17 },
  { name: "Bearing Dealers", count: 7 },
  { name: "Beauty Academies", count: 12 },
  { name: "Beauty Clinics", count: 15 },
  { name: "Beauty Salons & Parlours", count: 179 },
  { name: "Belt & Buckle Manufacturers", count: 6 },
  { name: "Bengali Restaurants", count: 5 },
  { name: "Beverages", count: 9 },
  { name: "Bicycle Dealers", count: 16 },
  { name: "Bike On Rent", count: 11 },
  { name: "Bike Service Centres", count: 37 },
  { name: "Bill Printing Machine Dealers", count: 5 },
  { name: "Billiard Halls", count: 6 },
  { name: "Biogas Plants", count: 4 },
  { name: "Biometric Equipment", count: 7 },
  { name: "Birthday Party Organisers", count: 13 },
  { name: "Blood Banks & Donation Centres", count: 17 },
  { name: "Boat Dealers", count: 5 },
  { name: "Book Publishers", count: 8 },
  { name: "Book Shops & Dealers", count: 47 },
  { name: "Borewell Contractors", count: 19 },
  { name: "Boutiques", count: 33 },
  { name: "Bowling", count: 5 },
  { name: "Boxing Classes", count: 6 },
  { name: "BPO & Call Centres", count: 14 },
  { name: "Brass & Bronze Products", count: 7 },
  { name: "Brick Manufacturers", count: 11 },
  { name: "Bridal Wear Shops", count: 22 },
  { name: "Builders, Contractors & Developers", count: 201 },
  { name: "Building Material Dealers", count: 41 },
  { name: "Bulk SMS Providers", count: 6 },
  { name: "Bus & Van Rental Services", count: 27 },
  { name: "Bus Ticketing Agents", count: 9 },
  { name: "Business Brokers", count: 6 },
  { name: "Business & Management Consultants", count: 43 },
  { name: "Business Schools", count: 5 },

  // C
  { name: "Cable TV Operators", count: 14 },
  { name: "CAD & CAM Services", count: 7 },
  { name: "Calendar & Diaries", count: 5 },
  { name: "Camera Dealers", count: 9 },
  { name: "Camera Repairs", count: 11 },
  { name: "Cancer Hospitals", count: 6 },
  { name: "Candle Manufacturers", count: 5 },
  { name: "Cane Furniture Shops", count: 6 },
  { name: "Carpenters", count: 34 },
  { name: "Carpet Dealers", count: 12 },
  { name: "CAT Coaching Centres", count: 5 },
  { name: "Cattle Feed Dealers", count: 9 },
  { name: "CCTV Dealers", count: 22 },
  { name: "Ceiling Works", count: 11 },
  { name: "Cement Dealers", count: 24 },
  { name: "Ceramic Dealers", count: 13 },
  { name: "Chartered Accountants", count: 47 },
  { name: "Chemical Dealers", count: 19 },
  { name: "Chemistry Coaching Classes", count: 11 },
  { name: "Chest Specialists", count: 8 },
  { name: "Children & Kids Wear", count: 53 },
  { name: "Chinese Restaurants", count: 18 },
  { name: "Chocolate Dealers", count: 12 },
  { name: "Churches", count: 31 },
  { name: "Civil Services Coaching", count: 6 },
  { name: "Clocks & Accessories", count: 7 },
  { name: "Clothing & Apparel Stores", count: 134 },
  { name: "Co-Working Spaces", count: 9 },
  { name: "Coaching & Tuition Centres", count: 90 },
  { name: "Coconut Exporters", count: 7 },
  { name: "Coffee Shops & Cafés", count: 37 },
  { name: "Coir Products", count: 6 },
  { name: "Cold Storages", count: 8 },
  { name: "Colleges & Universities", count: 34 },
  { name: "Community Halls & Convention Centres", count: 24 },
  { name: "Computer & Laptop Dealers", count: 45 },
  { name: "Computer Repairs", count: 31 },
  { name: "Contact Lens Dealers", count: 12 },
  { name: "Cooking Classes", count: 8 },
  { name: "Cosmetic Surgery Clinics", count: 7 },
  { name: "Cosmetics Dealers", count: 22 },
  { name: "Courier, Cargo & Logistics Services", count: 45 },
  { name: "Cranes & Lifts", count: 9 },
  { name: "Cricket Academies", count: 12 },
  { name: "Curtain Dealers", count: 14 },

  // D
  { name: "Dairy Products", count: 21 },
  { name: "Dance Classes", count: 31 },
  { name: "Data Recovery Services", count: 6 },
  { name: "Day Care & Pre-Schools", count: 48 },
  { name: "Decorators & Event Decoration", count: 36 },
  { name: "Dental Colleges", count: 3 },
  { name: "Dentists & Dental Clinics", count: 75 },
  { name: "Departmental Stores", count: 18 },
  { name: "Dermatologists & Skin Specialists", count: 26 },
  { name: "Diagnostic & Pathology Labs", count: 66 },
  { name: "Driving Schools", count: 14 },
  { name: "Dry Cleaning & Laundry Services", count: 53 },
  { name: "Dry Fruits Dealers", count: 13 },
  { name: "DTH Services", count: 8 },
  { name: "Dyeing Units", count: 6 },

  // E
  { name: "E-Commerce Consultants", count: 7 },
  { name: "Educational Consultants", count: 15 },
  { name: "Educational Institutions", count: 29 },
  { name: "Electric Motor Dealers", count: 11 },
  { name: "Electricians & Electrical Contractors", count: 84 },
  { name: "Electronics & Electrical Goods Dealers", count: 51 },
  { name: "Emergency Services", count: 15 },
  { name: "Embroidery & Zari Services", count: 23 },
  { name: "Engineers & Engineering Consultants", count: 67 },
  { name: "ENT Specialists", count: 13 },
  { name: "Entrance Exam Coaching", count: 21 },
  { name: "Event & Wedding Management", count: 52 },
  { name: "Eye Hospitals & Clinics", count: 24 },

  // F
  { name: "Fancy Stores", count: 19 },
  { name: "Fashion Designers", count: 11 },
  { name: "Fashion Institutes", count: 7 },
  { name: "Fast Food Centres & Food Courts", count: 42 },
  { name: "Fertilizer Dealers", count: 12 },
  { name: "Financial & Investment Advisors", count: 74 },
  { name: "Fire & Safety Equipment Dealers", count: 17 },
  { name: "Fish Dealers", count: 27 },
  { name: "Florists", count: 17 },
  { name: "Flour Mills", count: 10 },
  { name: "Foam Dealers", count: 7 },
  { name: "Food Processors", count: 13 },
  { name: "Football Academies", count: 9 },
  { name: "Footwear & Shoe Dealers", count: 60 },
  { name: "Furniture Dealers & Shops", count: 67 },

  // G
  { name: "Game Parlours", count: 7 },
  { name: "Gas Agencies", count: 18 },
  { name: "Gem & Jewellery Dealers", count: 41 },
  { name: "General Stores", count: 56 },
  { name: "Gift Shops", count: 24 },
  { name: "Glass Dealers", count: 21 },
  { name: "Government Offices", count: 34 },
  { name: "Graphic Designers", count: 19 },
  { name: "Grocery Stores", count: 88 },
  { name: "Guest Houses", count: 26 },
  { name: "Gym & Fitness Centres", count: 47 },

  // H
  { name: "Hair & Beauty Salons", count: 92 },
  { name: "Handicrafts Shops", count: 23 },
  { name: "Hardware Stores", count: 44 },
  { name: "Health & Wellness Centres", count: 31 },
  { name: "Hobby Classes", count: 18 },
  { name: "Home Appliances Dealers", count: 39 },
  { name: "Home Interiors", count: 52 },
  { name: "Home Services", count: 64 },
  { name: "Home Stay & Resorts", count: 37 },
  { name: "Hospitals", count: 58 },
  { name: "Hotels", count: 96 },
  { name: "Housekeeping Services", count: 22 },

  // I
  { name: "Ice Cream Parlours", count: 29 },
  { name: "Immigration Consultants", count: 9 },
  { name: "Insurance Agents", count: 61 },
  { name: "Insurance Brokers", count: 27 },
  { name: "Interior Designers", count: 43 },
  { name: "Internet & Broadband Services", count: 16 },
  { name: "Investment Consultants", count: 34 },
  { name: "ISO Certification Consultants", count: 8 },
  { name: "IT & Computer Training Institutes", count: 41 },

  // J
  { name: "JCB Hiring", count: 11 },
  { name: "Jewellery Dealers", count: 74 },
  { name: "Job Consultants", count: 26 },
  { name: "Jute Products Dealers", count: 6 },

  // K
  { name: "Key Makers & Locksmiths", count: 17 },
  { name: "Kids Wear", count: 38 },
  { name: "Kitchen Equipment & Suppliers", count: 21 },
  { name: "Kurti Dealers", count: 19 },

  // L
  { name: "Laboratories", count: 24 },
  { name: "Language Classes", count: 14 },
  { name: "Laser Toner & Cartridge Dealers", count: 12 },
  { name: "Laundry Services", count: 33 },
  { name: "Leather Goods Dealers", count: 15 },
  { name: "Libraries", count: 9 },
  { name: "Lighting Dealers", count: 27 },
  { name: "Loan Consultants", count: 48 },
  { name: "Logistics Services", count: 22 },

  // M
  { name: "Machine Tool Dealers", count: 13 },
  { name: "Magnetic & Nameplates", count: 7 },
  { name: "Manpower Services", count: 34 },
  { name: "Marketing Services", count: 29 },
  { name: "Marriage Halls", count: 41 },
  { name: "Martial Arts Classes", count: 11 },
  { name: "Massage Centres", count: 26 },
  { name: "Mattress Dealers", count: 18 },
  { name: "Meat & Poultry Shops", count: 12 },
  { name: "Medical Colleges", count: 6 },
  { name: "Medical Equipment Dealers", count: 31 },
  { name: "Medical Stores", count: 118 },
  { name: "Menswear", count: 46 },
  { name: "Milk & Dairy Products", count: 29 },
  { name: "Mobile Phone Dealers", count: 97 },
  { name: "Mobile Phone Repairs", count: 68 },
  { name: "Modular Kitchen Dealers", count: 37 },
  { name: "Mortgage Services", count: 16 },
  { name: "Mosquito & Pest Control", count: 21 },
  { name: "Motor Driving Schools", count: 13 },
  { name: "Movers & Packers", count: 34 },
  { name: "Music Classes", count: 23 },
  { name: "Musical Instrument Dealers", count: 12 },

  // N
  { name: "Nail Art Studios", count: 15 },
  { name: "Name Board Makers", count: 19 },
  { name: "Naturopathy Centres", count: 8 },
  { name: "Natural Health Care", count: 11 },
  { name: "Newspaper Dealers", count: 9 },
  { name: "Non-Profit Organisations", count: 22 },
  { name: "Nutrition & Diet Consultants", count: 17 },
  { name: "Nursery & Garden Centres", count: 26 },
  { name: "Nuts & Dry Fruits", count: 14 },
  { name: "News Agencies", count: 9 },

  // O
  { name: "Obstetrics & Gynaecology", count: 34 },
  { name: "Oncologists", count: 10 },
  { name: "Online Shopping", count: 12 },
  { name: "Ophthalmologists", count: 27 },
  { name: "Opticians & Optical Dealers", count: 53 },
  { name: "Organic Products", count: 24 },
  { name: "Orthopaedic Doctors", count: 31 },

  // P
  { name: "Packers & Movers", count: 29 },
  { name: "Paint Dealers", count: 38 },
  { name: "Pandits & Priest Services", count: 16 },
  { name: "Paper Dealers", count: 13 },
  { name: "Pathology Labs", count: 44 },
  { name: "Pest Control Services", count: 27 },
  { name: "Pet Shops", count: 18 },
  { name: "Pharmacies", count: 74 },
  { name: "Photography Services", count: 63 },
  { name: "Physiotherapists", count: 39 },
  { name: "Placement Consultants", count: 24 },
  { name: "Plastic & Cosmetic Surgeons", count: 9 },
  { name: "Play Schools", count: 51 },
  { name: "Plumbers", count: 46 },
  { name: "Plywood Dealers", count: 21 },
  { name: "Police Stations", count: 12 },
  { name: "Post Offices", count: 17 },
  { name: "Power Backup Dealers", count: 23 },
  { name: "Printers", count: 34 },
  { name: "Psychiatrists", count: 16 },
  { name: "PU Colleges", count: 28 },

  // Q
  { name: "Quality Certification Services", count: 7 },
  { name: "Quartz Dealers", count: 4 },
  { name: "Quilt Dealers", count: 6 },
  { name: "Quran & Islamic Book Stores", count: 5 },

  // R
  { name: "Real Estate Agents", count: 87 },
  { name: "Recruitment Agencies", count: 31 },
  { name: "Refrigerator Dealers", count: 34 },
  { name: "Refrigerator Repairs", count: 41 },
  { name: "Religious Institutions", count: 62 },
  { name: "Restaurants", count: 214 },
  { name: "Resume Services", count: 11 },
  { name: "Rice Dealers", count: 29 },
  { name: "RO Water Purifiers", count: 37 },
  { name: "Road Transport", count: 24 },
  { name: "Rubber Dealers", count: 7 },

  // S
  { name: "Saree Dealers", count: 58 },
  { name: "Saw & Blade Dealers", count: 12 },
  { name: "School & College Buses", count: 17 },
  { name: "School Uniforms", count: 26 },
  { name: "Scrap Dealers", count: 21 },
  { name: "Security Services", count: 34 },
  { name: "Serviced Apartments", count: 19 },
  { name: "Sewing Machine Dealers", count: 14 },
  { name: "Sofa Dealers", count: 27 },
  { name: "Software Companies", count: 41 },
  { name: "Solar Panel Dealers", count: 33 },
  { name: "Spa & Massage Centres", count: 46 },
  { name: "Spectacles Dealers", count: 29 },
  { name: "Sports Goods Dealers", count: 31 },
  { name: "Stationery Dealers", count: 47 },
  { name: "Steel & Metal Fabrication", count: 24 },
  { name: "Stock Brokers", count: 18 },
  { name: "Supermarkets", count: 52 },
  { name: "Sweet Shops", count: 63 },

  // T
  { name: "Tailors & Ladies Tailors", count: 88 },
  { name: "Talent Schools", count: 14 },
  { name: "Tattoo Studios", count: 9 },
  { name: "Tax Consultants", count: 27 },
  { name: "Taxi Services", count: 43 },
  { name: "Tea Dealers", count: 16 },
  { name: "Telecom Equipment Dealers", count: 21 },
  { name: "Textile Dealers", count: 54 },
  { name: "Tiffin Centres", count: 68 },
  { name: "Tiles Dealers", count: 37 },
  { name: "Timber Dealers", count: 19 },
  { name: "Tours & Travels", count: 72 },
  { name: "Transport Contractors", count: 26 },
  { name: "Travel Agents", count: 38 },
  { name: "Tutoring Centres", count: 91 },

  // U
  { name: "Uniform Dealers", count: 23 },
  { name: "Unisex Salons", count: 34 },
  { name: "Urology Clinics", count: 11 },
  { name: "UPVC Windows Dealers", count: 16 },
  { name: "Used Cars Dealers", count: 44 },

  // V
  { name: "Vacuum Cleaner Dealers", count: 7 },
  { name: "Variety Stores", count: 29 },
  { name: "Vastu Consultants", count: 19 },
  { name: "Vehicle Finance", count: 31 },
  { name: "Veterinary Clinics", count: 24 },
  { name: "Video Editing & Production", count: 17 },
  { name: "Visa Consultants", count: 21 },
  { name: "Voltage Stabilizer Dealers", count: 9 },

  // W
  { name: "Wall Painters", count: 34 },
  { name: "Watch Dealers", count: 26 },
  { name: "Water Purifier Dealers", count: 42 },
  { name: "Water Suppliers", count: 37 },
  { name: "Waterproofing Contractors", count: 19 },
  { name: "Wealth Management", count: 14 },
  { name: "Website Designers", count: 33 },
  { name: "Wedding Card Dealers", count: 23 },
  { name: "Wedding Photographers", count: 51 },
  { name: "Weighing Scale Dealers", count: 11 },
  { name: "Welding Services", count: 16 },
  { name: "Wholesale Traders", count: 41 },
  { name: "Wood & Timber Dealers", count: 18 },

  // X
  { name: "X-Ray Clinics", count: 21 },
  { name: "Xerox Services", count: 34 },

  // Y
  { name: "Yoga Classes", count: 27 },
  { name: "Yoga Centres", count: 19 },

  // Z
  { name: "Zari Sarees", count: 8 },
  { name: "Zinc Dealers", count: 5 },
  { name: "Zip Dealers", count: 7 },
  { name: "Zumba Classes", count: 11 },
];